const polylineColors = {
  buses: "firebrick",
  trolleys: "gold",
  trams: "#0276FD",
  subwayLines: "#10579E",
  cycleways: "darkorange",
  reconstructions: "brown",
  corridors: "#37BC61",
};
export default polylineColors;
